<template>
  <div>
    <div class="col-12 px0 flex flex-wrap imageArray">
      <!-- desktop -->
      <div class="col-6 mb3 px1" v-for="image in images" :key="image.ImageId" v-if="!showMobile && !showXXL">
        <div class="col-12 px0" data-download="true">
            <b-img :src="image.FileLocation.replace('/photos/', '')" alt="" fluid-grow v-if="image.FileLocation.includes('https://imagedelivery.net')"></b-img>
            <b-img :src="image.FileLocation" alt="" fluid-grow v-else></b-img>
        </div>
        <div class="col-12 px0 my1 flex justify-between items-center">
          <button @click="change_position(image.ImageId,'first')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-left"><path d='M2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05L2.757 7z' /></svg>
          </button>
          <button @click="change_position(image.ImageId,'left')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4.5 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-left"><path d='M8.828 7.071l4.95 4.95a1 1 0 1 1-1.414 1.414L6.707 7.778a1 1 0 0 1 0-1.414L12.364.707a1 1 0 0 1 1.414 1.414l-4.95 4.95zm-6 0l4.95 4.95a1 1 0 1 1-1.414 1.414L.707 7.778a1 1 0 0 1 0-1.414L6.364.707a1 1 0 1 1 1.414 1.414l-4.95 4.95z' /></svg>
          </button>
          <button class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -2.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-refresh"><path d='M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z' /></svg>
          </button>
          <button @click="change_position(image.ImageId,'right')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-right"><path d='M11.314 7.071l-4.95-4.95A1 1 0 0 1 7.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95zm-6 0l-4.95-4.95A1 1 0 1 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
          </button>
          <button @click="change_position(image.ImageId,'last')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
          </button>
          <button @click="edit_image(image.FileLocation,image.ImageId)"  class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2.5 -2.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-pencil-f"><path d='M16.318 6.11l-3.536-3.535 1.415-1.414c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.829L16.318 6.11zm-1.414 1.415l-9.9 9.9-4.596 1.06 1.06-4.596 9.9-9.9 3.536 3.536z' /></svg>
          </button>
          <button @click="delete_image(image.ImageId)" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt-f"><path d='M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z' /></svg>
          </button>
        </div>
      </div>
      <!-- mobile -->
      <div class="col-12 mb3 px0" v-for="image in images" :key="image.ImageId" v-if="showMobile">
        <div class="col-12 px0" data-download="true">
            <b-img :src="image.FileLocation.replace('/photos/', '')" alt="" fluid-grow v-if="image.FileLocation.includes('https://imagedelivery.net')"></b-img>
            <b-img :src="image.FileLocation" alt="" fluid-grow v-else></b-img>
        </div>
        <div class="col-12 px0 my1 flex justify-between items-center">
          <button @click="change_position(image.ImageId,'first')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-left"><path d='M2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05L2.757 7z' /></svg>
          </button>
          <button @click="change_position(image.ImageId,'left')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4.5 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-left"><path d='M8.828 7.071l4.95 4.95a1 1 0 1 1-1.414 1.414L6.707 7.778a1 1 0 0 1 0-1.414L12.364.707a1 1 0 0 1 1.414 1.414l-4.95 4.95zm-6 0l4.95 4.95a1 1 0 1 1-1.414 1.414L.707 7.778a1 1 0 0 1 0-1.414L6.364.707a1 1 0 1 1 1.414 1.414l-4.95 4.95z' /></svg>
          </button>
          <button class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -2.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-refresh"><path d='M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z' /></svg>
          </button>
          <button @click="change_position(image.ImageId,'right')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-right"><path d='M11.314 7.071l-4.95-4.95A1 1 0 0 1 7.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95zm-6 0l-4.95-4.95A1 1 0 1 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
          </button>
          <button @click="change_position(image.ImageId,'last')" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
          </button>
          <button @click="edit_image(image.FileLocation,image.ImageId)"  class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2.5 -2.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-pencil-f"><path d='M16.318 6.11l-3.536-3.535 1.415-1.414c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.829L16.318 6.11zm-1.414 1.415l-9.9 9.9-4.596 1.06 1.06-4.596 9.9-9.9 3.536 3.536z' /></svg>
          </button>
          <button @click="delete_image(image.ImageId)" class="border-none ghost-dark-button">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt-f"><path d='M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z' /></svg>
          </button>
        </div>
      </div>
      <!-- firma profile layout - desktop -->
      <div class="clearfix py2 px0 row" v-if="showXXL">
        <div class="col-3 mb3 px1" v-for="image in images" :key="image.ImageId" >
          <div class="col-12 px0" data-download="true">
            <b-img :src="image.FileLocation.replace('/photos/', '')" alt="" fluid-grow v-if="image.FileLocation.includes('https://imagedelivery.net')"></b-img>
            <b-img :src="image.FileLocation" alt="" fluid-grow v-else></b-img>
          </div>
          <div class="col-12 px0 my1 flex justify-between items-center">
            <button @click="change_position(image.ImageId,'first')" class="border-none ghost-dark-button">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-left"><path d='M2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05L2.757 7z' /></svg>
            </button>
            <button @click="change_position(image.ImageId,'left')" class="border-none ghost-dark-button">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4.5 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-left"><path d='M8.828 7.071l4.95 4.95a1 1 0 1 1-1.414 1.414L6.707 7.778a1 1 0 0 1 0-1.414L12.364.707a1 1 0 0 1 1.414 1.414l-4.95 4.95zm-6 0l4.95 4.95a1 1 0 1 1-1.414 1.414L.707 7.778a1 1 0 0 1 0-1.414L6.364.707a1 1 0 1 1 1.414 1.414l-4.95 4.95z' /></svg>
            </button>
            <button class="border-none ghost-dark-button">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -2.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-refresh"><path d='M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z' /></svg>
            </button>
            <button @click="change_position(image.ImageId,'right')" class="border-none ghost-dark-button">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-right"><path d='M11.314 7.071l-4.95-4.95A1 1 0 0 1 7.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95zm-6 0l-4.95-4.95A1 1 0 1 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
            </button>
            <button @click="change_position(image.ImageId,'last')" class="border-none ghost-dark-button">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-8 -5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-right"><path d='M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z' /></svg>
            </button>
            <button @click="edit_image(image.FileLocation,image.ImageId)"  class="border-none ghost-dark-button">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2.5 -2.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-pencil-f"><path d='M16.318 6.11l-3.536-3.535 1.415-1.414c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.829L16.318 6.11zm-1.414 1.415l-9.9 9.9-4.596 1.06 1.06-4.596 9.9-9.9 3.536 3.536z' /></svg>
            </button>
            <button @click="delete_image(image.ImageId)" class="border-none ghost-dark-button">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt-f"><path d='M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z' /></svg>
            </button>
          </div>
        </div>
      </div>
      <template>
        <div class="clearfix" ></div>
        <div class="clearfix col-7 px0" v-if="showXXL">
          <!-- first image -->
          <div class="col col-6 px0" v-if="images[0]" :key="images.ImageId">
            <b-img :src="images[0].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[0].FileLocation.includes('https://imagedelivery.net')"></b-img>
            <b-img :src="images[0].FileLocation" fluid-grow v-else></b-img>
          </div>
          <!-- right column -->
          <div class="col col-6 px0">
            <div class="clearfix">
              <!-- left-top -->
              <div class="col col-6 px0" v-if="images[1]" :key="images.ImageId">
                <b-img :src="images[1].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[1].FileLocation.includes('https://imagedelivery.net')"></b-img>
                <b-img :src="images[1].FileLocation" fluid-grow v-else>></b-img>
              </div>
              <!-- right-top -->
              <div class="col col-6 px0" v-if="images[2]" :key="images.ImageId">
                <b-img :src="images[2].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[2].FileLocation.includes('https://imagedelivery.net')"></b-img>
                <b-img :src="images[2].FileLocation" fluid-grow v-else>></b-img>
              </div>
            </div>
            <div class="clearfix">
              <!-- left-bottom -->
              <div class="col col-6 px0" v-if="images[3]" :key="images.ImageId">
                <b-img :src="images[3].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[3].FileLocation.includes('https://imagedelivery.net')"></b-img>
                <b-img :src="images[3].FileLocation" fluid-grow v-else>></b-img>
              </div>
              <!-- right bottom -->
              <div class="col col-6 px0" v-if="images[4]" :key="images.ImageId">
                <b-img :src="images[4].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[4].FileLocation.includes('https://imagedelivery.net')"></b-img>
                <b-img :src="images[4].FileLocation" fluid-grow v-else></b-img>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 px0 flex flex-column md-hide lg-hide">
          <div class="clearfix">
            <div class="col-12 px0" v-if="images[0]">
              <b-img :src="images[0].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[0].FileLocation.includes('https://imagedelivery.net')"></b-img>
              <b-img :src="images[0].FileLocation" fluid-grow v-else></b-img>
            </div>
          </div>
          <div class="clearfix">
            <div class="col col-6 px0" v-if="images[2]">
              <b-img :src="images[1].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[1].FileLocation.includes('https://imagedelivery.net')"></b-img>
              <b-img :src="images[1].FileLocation" fluid-grow v-else></b-img>
            </div>
            <div class="col col-6 px0" v-if="images[3]">
              <b-img :src="images[2].FileLocation.replace('/photos/', '')" fluid-grow v-if="images[2].FileLocation.includes('https://imagedelivery.net')"></b-img>
              <b-img :src="images[2].FileLocation" fluid-grow v-else></b-img>
            </div>
          </div>
        </div>
      </template>
    </div>
    <template>

      <div class="clearfix" v-if="showXXL">
        <div class="col-7 py2">
          <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
        </div>
      </div>
      <div class="clearfix" v-if="showMobile">
        <div class="col-12 py2">
          <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
        </div>
      </div>
      <div class="clearfix" v-if="!showMobile && !showXXL">
        <div class="col-8 py2">
          <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
        </div>
      </div>
    </template>
    <div class="py2"></div>
  </div>
</template>
<script>
import Dropzone from 'vue2-dropzone'
export default {
  name: 'profileimages',
  props: ['images'],
  components: {
    Dropzone
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1900) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
  },
  data: function () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        showMobile: false,
        maxFilesize: 17,
        createImageThumbnails: true,
        addRemoveLinks: true,
        acceptedFiles: 'image/*',
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: ''
    }
  },
  computed: {
    dropzoneSettings () {
      let defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      }
      Object.keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key]
      }, this)
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false
        this.isS3 = true
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue
        }
      }
      return defaultValues
    }
  },
  methods: {
    'showSuccess': function (file) {
      this.$emit('Reload')
      $('html, body').animate({
        scrollTop: 0
      }, 600)
    },
    change_position (imageId, position) {
      this.$emit('moveImage', imageId, position)
    },
    delete_image (imageId) {
      this.$emit('delete_image', imageId)
    },
    edit_image (FileLocation, imageId) {
      this.$emit('edit_image', FileLocation, imageId)
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('operation', 'uploadImages')
    }
  }
}
</script>
<style lang="less">
.vue-dropzone {
  width:100%;
  padding: 0;
  border: 0;
  background: white;
  &:hover {
    background: white!important;
  }
}
.dz-preview {
  display: none!important;
}
</style>



// WEBPACK FOOTER //
// profileimages.vue?3953b4e8